import { render, staticRenderFns } from "./VerifiedResults.vue?vue&type=template&id=751274b1"
import script from "./VerifiedResults.vue?vue&type=script&lang=js"
export * from "./VerifiedResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlightsListItem: require('/home/forge/ab.farescraper.com/components/FlightsListItem.vue').default})
